<template>
  <v-content class="content">
    <v-layout justify-center align-center style="min-height: 100vh">
      <v-card class="content-container" style="content-container">
        <v-progress-circular
          indeterminate
          size="50"
          class="primary--text ma-5"
        />

        <v-card-text> Processing. Please wait... </v-card-text>
      </v-card>
    </v-layout>
  </v-content>
</template>

<script>
import API from '@/api';
import UtilsMixins from '@/mixins/UtilsMixins';

export default {
  name: 'CheckoutCompleted',

  mixins: [UtilsMixins],

  data() {
    return {};
  },

  methods: {
    async verifyCheckoutSession() {
      let verified = false;

      while (!verified) {
        try {
          const response = await API.questionnaire.verifyCheckoutSession({
            companyId: this.$route.query.companyId,
            questionnaireId: this.$route.query.questionnaireId,
          });

          if (
            response.data.deposit_status === 'paid' ||
            response.data.deposit_status === 'payment_pending'
          ) {
            this.$router.push(response.data.redirect_url);
            verified = true;
          }
        } catch (error) {
          console.error(error);
        } finally {
          await this.sleep(1000);
        }
      }
    },
  },

  async created() {
    this.verifyCheckoutSession();
  },
};
</script>

<style lang="postcss" scoped>
.content-container {
  width: 400px;
}
</style>
